import CustomInput from '../CustomInput';

const THIRTY_NUMBERS = /^[0-9]{0,13}$/;
// const THIRTY_NUMBERS = /^$\d{13}$/;

class AnyDocNumberInput extends CustomInput {
  transform = value => value.trim();

  validate = value => THIRTY_NUMBERS.test(value);
}

export default AnyDocNumberInput;
